import { Bump, BumpItem } from "../../../api/generated/models";

// Only the slice of a Bump these helpers read. Structural, not Pick<Bump>, so a caller — or a test —
// can pass the items without the eight unrelated required Bump fields.
type TranslatableBump = Pick<Bump, "items">;

/**
 * The bump whose texts the GUI should show. create_session builds its bump from the DEFAULT DS Web
 * Admin account, because ?account= is applied only afterwards; set_current_sds_account returns the
 * active account's own bump, so that one wins whenever it is present. Without this, every non-default
 * account renders the default account's GDPR consent wording (NGOP-1510). get_current_sds_account
 * deliberately returns no bump — that path never changed account, so create_session's is already right.
 */
export const selectTranslationBump = (
    sessionData: { bumps: TranslatableBump[] },
    account: { bump?: TranslatableBump | null } | null
): TranslatableBump => account?.bump ?? sessionData.bumps[0];

/**
 * Bump items keyed id -> text, the dictionary behind TranslationMap. An item with no text is left out
 * rather than mapped to a blank, so the lookup falls through to TranslationMap.get's raw-key default.
 */
export const buildGuiTranslations = (bump: TranslatableBump): Record<string, string> => {
    // Accumulate into a local object rather than reduce-with-spread: a bump carries every GUI text in
    // the configurator, and copying the map per item would make this quadratic.
    const translations: Record<string, string> = {};
    bump.items.forEach((item: BumpItem) => {
        if (item.shortText) {
            translations[item.id] = item.shortText;
        }
    });
    return translations;
};
